(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[255],{

/***/ 44020:
/***/ (function(module) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return decodeURIComponent(components.join(''));
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher);

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher);
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),

/***/ 92806:
/***/ (function(module) {

"use strict";

module.exports = function (obj, predicate) {
	var ret = {};
	var keys = Object.keys(obj);
	var isArr = Array.isArray(predicate);

	for (var i = 0; i < keys.length; i++) {
		var key = keys[i];
		var val = obj[key];

		if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) {
			ret[key] = val;
		}
	}

	return ret;
};


/***/ }),

/***/ 15700:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vefverslun/[slug]",
      function () {
        return __webpack_require__(36825);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 68164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CategoryCard; }
/* harmony export */ });
/* unused harmony export IconContainer */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(186);
/* harmony import */ var styled_tools__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41145);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var remixicon_react_ArrowRightUpLineIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28698);
/* harmony import */ var remixicon_react_ArrowRightUpLineIcon__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_ArrowRightUpLineIcon__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var _themes_theme__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69431);
/* harmony import */ var _typography__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56795);
/* harmony import */ var _styles_shadowStyles__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(23633);
/* harmony import */ var _styles_imageStyles__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(42521);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  padding: 16px;\n  color: ",
        ";\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  transition: background-color 0.15s;\n\n  ",
        " {\n    position: relative;\n    padding-top: 16px;\n    padding-bottom: 8px;\n\n    &:before {\n      position: absolute;\n      content: '';\n      top: 0;\n      left: 0;\n      width: 20px;\n      border-top: 1px solid ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  visibility: hidden;\n  position: absolute;\n  top: 0;\n  right: 0;\n  transition: visibility 0.15s;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  height: 250px;\n  margin-bottom: 20px;\n  transition: color 0.5s, border-color 0.5s, background-color 0.5s;\n  border: 1px solid transparent;\n  cursor: pointer;\n  ",
        ";\n\n  &:hover&:not(:disabled) {\n    border: 1px solid ",
        ";\n\n    ",
        " {\n      visibility: visible;\n    }\n  }\n\n  &:active {\n    ",
        " {\n      background-color: ",
        ";\n    }\n  }\n\n  ",
        " {\n    background-color: ",
        ";\n  }\n\n  &:focus,\n  &:focus-visible {\n    outline: 3px solid ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}











var CategoryTitleBox = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].div(_templateObject(), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("secondary"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("white"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("black20"), _typography__WEBPACK_IMPORTED_MODULE_7__.H6, (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("red"));
var IconContainer = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].div(_templateObject1());
var CardWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].a(_templateObject2(), (0,_styles_shadowStyles__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)({
    color: "red",
    outlined: false,
    length: 8,
    showOnHover: true
}), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("red"), IconContainer, CategoryTitleBox, (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("red10"), _styles_imageStyles__WEBPACK_IMPORTED_MODULE_9__/* .BackgroundImageCover */ .G, (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("white"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("sky"));
function CategoryCard(param) {
    var src = param.src, title = param.title, description = param.description, href = param.href;
    if (!href) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_5__["default"], {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CardWrapper, {
            children: [
                src ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles_imageStyles__WEBPACK_IMPORTED_MODULE_9__/* .BackgroundImageCover */ .G, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_3__["default"], {
                        layout: "fill",
                        objectFit: "contain",
                        objectPosition: "center",
                        src: src
                    })
                }) : null,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CategoryTitleBox, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconContainer, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_ArrowRightUpLineIcon__WEBPACK_IMPORTED_MODULE_4___default()), {
                                color: _themes_theme__WEBPACK_IMPORTED_MODULE_6__/* ["default"].palette.red */ .Z.palette.red
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography__WEBPACK_IMPORTED_MODULE_7__.H6, {
                            children: title || "V\xf6ruflokkur"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography__WEBPACK_IMPORTED_MODULE_7__/* .PSmall */ .zK, {
                            color: "black40",
                            children: description
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 36825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-bootstrap-grid/dist/index.js
var dist = __webpack_require__(54572);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./src/api/saleor/generated/index.tsx
var generated = __webpack_require__(49554);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.js + 151 modules
var motion = __webpack_require__(87751);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.js + 2 modules
var AnimatePresence = __webpack_require__(84441);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./src/components/content/DatocmsContent.tsx + 30 modules
var DatocmsContent = __webpack_require__(32437);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useWindowSize.js + 3 modules
var useWindowSize = __webpack_require__(72977);
// EXTERNAL MODULE: ./src/components/products/index.tsx + 38 modules
var products = __webpack_require__(18254);
// EXTERNAL MODULE: ./node_modules/styled-tools/dist/es/index.js + 6 modules
var es = __webpack_require__(41145);
// EXTERNAL MODULE: ./src/themes/theme.ts
var theme = __webpack_require__(69431);
// EXTERNAL MODULE: ./src/themes/index.tsx
var themes = __webpack_require__(52287);
// EXTERNAL MODULE: ./src/components/layout/index.ts + 8 modules
var layout = __webpack_require__(49012);
// EXTERNAL MODULE: ./src/components/typography/index.tsx + 1 modules
var typography = __webpack_require__(56795);
// EXTERNAL MODULE: ./src/components/category/CategoryCard.tsx
var CategoryCard = __webpack_require__(68164);
// EXTERNAL MODULE: ./node_modules/remixicon-react/CloseLineIcon.js
var remixicon_react_CloseLineIcon = __webpack_require__(46550);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(17563);
// EXTERNAL MODULE: ./src/utils/products.ts
var utils_products = __webpack_require__(5979);
// EXTERNAL MODULE: ./src/components/form/index.tsx + 3 modules
var components_form = __webpack_require__(27618);
;// CONCATENATED MODULE: ./src/components/category/CategoryFilterBar.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 24px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border: 1px solid ",
        ";\n  height: 50px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  z-index: 99;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin-top: 10px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  padding: 0px 10px;\n  margin-right: 10px;\n  background-color: ",
        ";\n  color: ",
        ";\n\n  ",
        " {\n    margin-right: 10px;\n    font-weight: 600;\n  }\n\n  svg {\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 600;\n  border-bottom: 1px solid ",
        ";\n  margin-left: 10px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}












var Wrapper = styled_components_browser_esm["default"].div(_templateObject());
var CategoryBar = styled_components_browser_esm["default"].div(_templateObject1(), (0,es/* palette */.DG)("black"), (0,es/* palette */.DG)("white"));
var Filters = styled_components_browser_esm["default"].div(_templateObject2());
var SelectedFilters = styled_components_browser_esm["default"].div(_templateObject3());
var Filter = styled_components_browser_esm["default"].div(_templateObject4(), (0,es/* palette */.DG)("black"), (0,es/* palette */.DG)("white"), typography/* PSmall */.zK);
var Clear = styled_components_browser_esm["default"].a(_templateObject5(), (0,es/* palette */.DG)("black"));
var orderOptions = [
    {
        value: "new",
        label: "N\xfdjast"
    },
    {
        value: "price_desc",
        label: "Ver\xf0 (h\xe6sta - l\xe6gsta)"
    },
    {
        value: "price_asc",
        label: "Ver\xf0 (l\xe6gsta - h\xe6sta)"
    },
    {
        value: "alph_asc",
        label: "Stafr\xf3fsr\xf6\xf0 (A - \xd6)"
    },
    {
        value: "alph_desc",
        label: "Stafr\xf3fsr\xf6\xf0 (\xd6 - A)"
    }, 
];
var orderOptionsMap = (0,lodash.fromPairs)(orderOptions === null || orderOptions === void 0 ? void 0 : orderOptions.map(function(o) {
    return [
        o.value,
        o
    ];
}));
function CategoryFilterBar(param) {
    var filterableAttr = param.filterableAttr;
    var removeFilters = function removeFilters(filter) {
        updateFilters(activeFilters.filter(function(b) {
            return b !== filter;
        }));
    };
    var removeAll = function removeAll() {
        updateFilters([]);
    };
    var ref4;
    var router = useRouter();
    var ref1;
    var queryParams = mapValues(qs.parse((ref1 = router.asPath.split("?")[1]) !== null && ref1 !== void 0 ? ref1 : ""), function(v) {
        if (!v) {
            return null;
        }
        return isArray(v) ? v : v.split(",");
    });
    var attrOptions = toAttrOption(filterableAttr);
    var activeFilters = attrOptions === null || attrOptions === void 0 ? void 0 : attrOptions.map(function(opt) {
        var ref5;
        return opt === null || opt === void 0 ? void 0 : (ref5 = opt.attrValues) === null || ref5 === void 0 ? void 0 : ref5.filter(function(o) {
            var ref;
            return queryParams === null || queryParams === void 0 ? void 0 : (ref = queryParams.filters) === null || ref === void 0 ? void 0 : ref.includes(o.slug);
        });
    }).flat();
    var activeCategorySlug = router.query.slug;
    var setSorting = useCallback(function(sort) {
        var params = _objectSpread({}, queryParams, {
            slug: activeCategorySlug
        });
        var search = qs.stringify(_objectSpread({}, params, {
            sort: sort
        }), {
            arrayFormat: "comma"
        });
        router.replace({
            search: search
        }, undefined);
    }, [
        queryParams,
        router,
        activeCategorySlug
    ]);
    // TODO: Hver filter fær forskeytið filters í router query params, hvernig laga ég það?
    var updateFilters = useCallback(function() {
        var filtersUpdate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        var filters = filtersUpdate.filter(isNotNull).map(function(f) {
            return "".concat(f.slug);
        });
        var params = _objectSpread({}, queryParams, {
            slug: activeCategorySlug
        });
        var query = _objectSpread({}, params, {
            filters: filters
        });
        router.replace({
            query: query
        }, undefined);
    }, [
        queryParams,
        router,
        activeCategorySlug
    ]);
    var handleSortChange = useCallback(function(changes) {
        var ref;
        setSorting((ref = changes.selectedItem) === null || ref === void 0 ? void 0 : ref.value);
    }, [
        setSorting
    ]);
    var handleFilterChange = useCallback(function(changes) {
        updateFilters(changes.selectedItems);
    }, [
        updateFilters
    ]);
    var ref2, ref3;
    return /*#__PURE__*/ _jsxs(Wrapper, {
        children: [
            /*#__PURE__*/ _jsxs(CategoryBar, {
                children: [
                    /*#__PURE__*/ _jsx(Filters, {
                        children: attrOptions === null || attrOptions === void 0 ? void 0 : attrOptions.map(function(opt) {
                            /*#__PURE__*/ return _jsx(MultiSelect, {
                                placeholder: opt.attrName,
                                items: opt.attrValues,
                                selectedItems: activeFilters,
                                handleSelectedItemsChange: handleFilterChange,
                                itemToString: function(option) {
                                    return (ref2 = option === null || option === void 0 ? void 0 : option.name) !== null && ref2 !== void 0 ? ref2 : "";
                                },
                                noBorder: true
                            }, opt.id);
                        })
                    }),
                    /*#__PURE__*/ _jsx(Filters, {
                        children: /*#__PURE__*/ _jsx(Select, {
                            placeholder: "Ra\xf0a",
                            items: orderOptions,
                            selectedItem: orderOptionsMap[((ref4 = queryParams.sort) === null || ref4 === void 0 ? void 0 : ref4[0]) || ""] || orderOptions[0],
                            handleSelectedItemChange: handleSortChange,
                            itemToString: function(option) {
                                return (ref3 = option === null || option === void 0 ? void 0 : option.label) !== null && ref3 !== void 0 ? ref3 : "";
                            },
                            align: "right",
                            noBorder: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(SelectedFilters, {
                children: [
                    activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.map(function(filter) {
                        return /*#__PURE__*/ _jsxs(Filter, {
                            children: [
                                /*#__PURE__*/ _jsx(PSmall, {
                                    children: filter.name
                                }),
                                /*#__PURE__*/ _jsx(CloseLineIcon, {
                                    size: 14,
                                    onClick: function() {
                                        return removeFilters(filter);
                                    }
                                })
                            ]
                        }, filter.id);
                    }),
                    activeFilters.length > 0 && /*#__PURE__*/ _jsx(Clear, {
                        onClick: removeAll,
                        children: "Hreinsa allt"
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/remixicon-react/ArrowRightLineIcon.js
var ArrowRightLineIcon = __webpack_require__(94187);
var ArrowRightLineIcon_default = /*#__PURE__*/__webpack_require__.n(ArrowRightLineIcon);
// EXTERNAL MODULE: ./node_modules/@apollo/client/index.js
var _apollo_client = __webpack_require__(46829);
// EXTERNAL MODULE: ./src/utils/isNotNull.ts
var utils_isNotNull = __webpack_require__(84403);
// EXTERNAL MODULE: ./src/utils/paths.ts
var paths = __webpack_require__(27827);
// EXTERNAL MODULE: ./src/components/common/Link.tsx
var Link = __webpack_require__(5695);
;// CONCATENATED MODULE: ./src/components/category/CategorySidebar.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function CategorySidebar_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function CategorySidebar_templateObject() {
    var data = CategorySidebar_taggedTemplateLiteral([
        "\n  z-index: 400;\n"
    ]);
    CategorySidebar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CategorySidebar_templateObject1() {
    var data = CategorySidebar_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  height: 50px;\n  padding: 0 16px;\n  margin-bottom: 4px;\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n\n  ",
        " {\n    display: flex;\n    align-items: center;\n  }\n\n  svg {\n    margin-right: 8px;\n    color: ",
        ";\n  }\n"
    ]);
    CategorySidebar_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CategorySidebar_templateObject2() {
    var data = CategorySidebar_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 16px;\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n"
    ]);
    CategorySidebar_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CategorySidebar_templateObject3() {
    var data = CategorySidebar_taggedTemplateLiteral([
        "\n  &:after {\n    content: '';\n    position: absolute;\n    bottom: 2px;\n    left: 0;\n    right: 0;\n    border-bottom: 2px solid ",
        ";\n    animation: slidein 0.25s;\n  }\n"
    ]);
    CategorySidebar_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CategorySidebar_templateObject4() {
    var data = CategorySidebar_taggedTemplateLiteral([
        "\n  position: relative;\n  padding: 5px 0;\n  cursor: pointer;\n  margin-bottom: 5px;\n  ",
        ";\n\n  &:hover {\n    @keyframes slidein {\n      from {\n        width: 0;\n      }\n\n      to {\n        width: 100%;\n      }\n    }\n\n    ",
        ";\n  }\n"
    ]);
    CategorySidebar_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}













var CategorySidebar_Wrapper = styled_components_browser_esm["default"].div(CategorySidebar_templateObject());
var Box = styled_components_browser_esm["default"].div(CategorySidebar_templateObject1(), (0,es/* palette */.DG)("black"), (0,es/* palette */.DG)("white"), typography/* Title6 */.L8, (0,es/* palette */.DG)("red"));
var SubCategoryList = styled_components_browser_esm["default"].div(CategorySidebar_templateObject2(), (0,es/* palette */.DG)("black"), (0,es/* palette */.DG)("white"));
var underlineStyles = (0,styled_components_browser_esm.css)(CategorySidebar_templateObject3(), (0,es/* palette */.DG)("red"));
var SubCategory = styled_components_browser_esm["default"].div(CategorySidebar_templateObject4(), (0,es/* ifProp */.fq)({
    selected: true
}, underlineStyles, ""), underlineStyles);
function CategorySidebar(param) {
    var category = param.category, isLandingPage = param.isLandingPage, setShowMobileSubCategoryList = param.setShowMobileSubCategoryList;
    var ref9, ref1, ref2, ref3, ref4;
    var width = (0,useWindowSize/* default */.Z)().width;
    var client = (0,_apollo_client.useApolloClient)();
    (0,react.useEffect)(function() {
        var ref, ref5, ref6;
        var ref7;
        // if level1
        var edges = (ref7 = category === null || category === void 0 ? void 0 : (ref = category.children) === null || ref === void 0 ? void 0 : ref.edges) !== null && ref7 !== void 0 ? ref7 : [];
        // if level2
        var parentEdges = category === null || category === void 0 ? void 0 : (ref5 = category.parent) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.children) === null || ref6 === void 0 ? void 0 : ref6.edges;
        var ref8;
        // Prefetch
        // either level1 or level2
        var categories = (ref8 = edges !== null && edges !== void 0 ? edges : parentEdges) !== null && ref8 !== void 0 ? ref8 : [];
        // all req categories slugs
        var slugs = categories.map(function(e) {
            return e.node.slug;
        });
        slugs.map(function() {
            var _ref = _asyncToGenerator(runtime_default().mark(function _callee(slug) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            return _ctx.abrupt("return", client.query({
                                query: generated/* CategoryDocument */.OtF,
                                variables: {
                                    slug: slug
                                }
                            }));
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(slug) {
                return _ref.apply(this, arguments);
            };
        }());
    }, [
        category,
        client
    ]);
    var handleShowMobileSubCategoryList = (0,react.useCallback)(function() {
        if (!setShowMobileSubCategoryList) {
            return;
        }
        setShowMobileSubCategoryList(false);
    }, [
        setShowMobileSubCategoryList
    ]);
    var parent = category === null || category === void 0 ? void 0 : category.parent;
    var edges1 = category === null || category === void 0 ? void 0 : (ref9 = category.children) === null || ref9 === void 0 ? void 0 : ref9.edges;
    var showCategory = (0,utils_isNotNull/* isNotNull */.K)(category);
    var showEdges = showCategory && (0,utils_isNotNull/* isNotNull */.K)(edges1) && edges1.length;
    var showParent = showCategory && !showEdges;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategorySidebar_Wrapper, {
        children: [
            width > themes/* gridTheme.breakpoints.md */.k.breakpoints.md && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    href: paths/* paths.categories */.H.categories,
                    shallow: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.H6, {
                        children: "V\xf6ruflokkar"
                    })
                })
            }),
            parent ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    href: "".concat(paths/* paths.categories */.H.categories, "/").concat(parent.slug),
                    shallow: true,
                    onClick: handleShowMobileSubCategoryList,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography/* Title6 */.L8, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowRightLineIcon_default()), {}),
                            " ",
                            parent.name
                        ]
                    })
                })
            }) : null,
            showEdges ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography/* Title6 */.L8, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowRightLineIcon_default()), {}),
                                " ",
                                category.name
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubCategoryList, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                href: "".concat(paths/* paths.categories */.H.categories, "/").concat((category === null || category === void 0 ? void 0 : category.slug) || ""),
                                // href={`${paths.account}`}
                                shallow: true,
                                onClick: handleShowMobileSubCategoryList,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubCategory, {
                                    selected: !isLandingPage,
                                    children: "Allar v\xf6rur"
                                })
                            }),
                            edges1.map(function(subCategory) {
                                var ref;
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    shallow: true,
                                    href: "".concat(paths/* paths.categories */.H.categories, "/").concat(((ref = subCategory.node) === null || ref === void 0 ? void 0 : ref.slug) || ""),
                                    onClick: handleShowMobileSubCategoryList,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubCategory, {
                                        children: subCategory.node.name
                                    })
                                }, subCategory.node.id);
                            })
                        ]
                    })
                ]
            }) : null,
            showParent ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubCategoryList, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: "".concat(paths/* paths.categories */.H.categories, "/").concat(((ref1 = category.parent) === null || ref1 === void 0 ? void 0 : ref1.slug) || ""),
                        shallow: true,
                        onClick: handleShowMobileSubCategoryList,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubCategory, {
                            selected: ((ref2 = category.parent) === null || ref2 === void 0 ? void 0 : ref2.id) === category.id,
                            children: "Allar v\xf6rur"
                        })
                    }),
                    category === null || category === void 0 ? void 0 : (ref3 = category.parent) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.children) === null || ref4 === void 0 ? void 0 : ref4.edges.map(function(subCategory) {
                        var ref;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: "".concat(paths/* paths.categories */.H.categories, "/").concat(((ref = subCategory.node) === null || ref === void 0 ? void 0 : ref.slug) || ""),
                            shallow: true,
                            onClick: handleShowMobileSubCategoryList,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubCategory, {
                                selected: subCategory.node.id === category.id,
                                children: subCategory.node.name
                            })
                        }, subCategory.node.id);
                    })
                ]
            }) : null
        ]
    });
};
CategorySidebar.CategoryList = function(param) {
    var category = param.category;
    var ref13, ref10;
    var ref11;
    var children = (ref11 = category === null || category === void 0 ? void 0 : (ref13 = category.children) === null || ref13 === void 0 ? void 0 : ref13.edges) !== null && ref11 !== void 0 ? ref11 : [];
    var parent = category === null || category === void 0 ? void 0 : category.parent;
    var ref12;
    var parentChildren = (ref12 = parent === null || parent === void 0 ? void 0 : (ref10 = parent.children) === null || ref10 === void 0 ? void 0 : ref10.edges) !== null && ref12 !== void 0 ? ref12 : [];
    var showChildren = !!children.length;
    var showParent = !showChildren && !!parent;
    if (!category || !showParent && !showChildren) {
        return null;
    }
    if (showChildren) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography/* Title6 */.L8, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowRightLineIcon_default()), {}),
                            " ",
                            category.name
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubCategoryList, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: "".concat(paths/* paths.categories */.H.categories, "/").concat((category === null || category === void 0 ? void 0 : category.slug) || ""),
                            shallow: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubCategory, {
                                selected: true,
                                children: "Allar v\xf6rur"
                            })
                        }),
                        children.map(function(subCategory) {
                            var ref;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                shallow: true,
                                href: "".concat(paths/* paths.categories */.H.categories, "/").concat(((ref = subCategory.node) === null || ref === void 0 ? void 0 : ref.slug) || ""),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubCategory, {
                                    children: subCategory.node.name
                                })
                            }, subCategory.node.id);
                        })
                    ]
                })
            ]
        });
    }
    if (!parent) {
        // This should not happen but, this is so remind TS that type is in fact not null
        return null;
    }
    var _slug;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubCategoryList, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                href: "".concat(paths/* paths.categories */.H.categories, "/").concat((_slug = parent.slug) !== null && _slug !== void 0 ? _slug : ""),
                shallow: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubCategory, {
                    selected: parent.id === category.id,
                    children: "Allar v\xf6rur"
                })
            }),
            parentChildren.map(function(subCategory) {
                var ref;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    href: "".concat(paths/* paths.categories */.H.categories, "/").concat(((ref = subCategory.node) === null || ref === void 0 ? void 0 : ref.slug) || ""),
                    shallow: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubCategory, {
                        selected: subCategory.node.id === category.id,
                        children: subCategory.node.name
                    })
                }, subCategory.node.id);
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/category/index.tsx




// EXTERNAL MODULE: ./src/components/common/index.tsx + 15 modules
var common = __webpack_require__(69446);
// EXTERNAL MODULE: ./src/components/buttons/index.tsx + 6 modules
var buttons = __webpack_require__(31494);
;// CONCATENATED MODULE: ./src/components/category/CategoryPage.tsx
function CategoryPage_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CategoryPage_templateObject() {
    var data = CategoryPage_taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    CategoryPage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CategoryPage_templateObject1() {
    var data = CategoryPage_taggedTemplateLiteral([
        "\n  postion: absolute;\n\n  top: 0;\n  left: 0;\n"
    ]);
    CategoryPage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CategoryPage_templateObject2() {
    var data = CategoryPage_taggedTemplateLiteral([
        "\n  width: 100%;\n  display: grid;\n  place-items: center;\n"
    ]);
    CategoryPage_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CategoryPage_templateObject3() {
    var data = CategoryPage_taggedTemplateLiteral([
        "\n  width: 100%;\n  .landing_container {\n    margin-top: -60px;\n    display: flex;\n    gap: 30px;\n    flex-direction: column;\n    justify-content: center;\n  }\n"
    ]);
    CategoryPage_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CategoryPage_templateObject4() {
    var data = CategoryPage_taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    CategoryPage_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function CategoryPage_templateObject5() {
    var data = CategoryPage_taggedTemplateLiteral([
        "\n  display: block;\n  position: relative;\n\n  ",
        "\n"
    ]);
    CategoryPage_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = CategoryPage_taggedTemplateLiteral([
        "\n  position: absolute;\n  z-index: ",
        ";\n  top: 48px;\n  left: 0;\n  width: 100%;\n  background-color: ",
        ";\n  pointer-events: ",
        ";\n  opacity: ",
        ";\n  transition: opacity 0.15s;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = CategoryPage_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  .message-box {\n    margin: 40px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = CategoryPage_taggedTemplateLiteral([
        "\n    position: relative;\n    top: 0;\n    border-top: border-top: 1px solid ",
        ";\n    border-bottom: none !important;\n    border-left: none !important;\n    border-right: none;\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = CategoryPage_taggedTemplateLiteral([
        "\n  position: absolute;\n  z-index: 10;\n  right: 0;\n  top: -60px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = CategoryPage_taggedTemplateLiteral([
        "\nposition: relative;\nwidth: 220px;\ndisplay: flex;\nflex-direction: column;\njustify-content: center;\nalign-items: center;\nbackground-color: ",
        ";\nborder-radius: 5px;\nborder: 1.5px solid ",
        ";\n  .sort-button {\n    background-color: transparent;\n    border: none !important;\n    outline: none !important;\n    width: 100%;\n    height: 40px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    span {\n      font-size: 16px;\n      flex-grow: 1;\n      display: flex;\n      justify-content: flex-start;\n    }\n  }\n}\n.options {\n  width: 100%;\n  position: absolute;\n  top: 40px;\n  z-index: 10;\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n  ",
        "\n  li {\n    padding: 5px;\n    button {\n    width: 100%;\n    text-align: left;\n    background-color: transparent;\n    border: none !important;\n    font-size: 16px;\n    &:hover {\n      color: ",
        ";\n    }\n    .selected {\n      button {\n        color: ",
        ";\n      }\n    }\n    }\n    &:hover {\n      cursor: pointer;\n    }\n  }\n}\n",
        "\nalign-self: flex-end;\nmargin-bottom: 10px;\n.arrow {\n  border: solid black;\n  border-width: 0 3px 3px 0;\n  display: inline-block;\n  padding: 3px;\n}\n.up {\n  transform: rotate(-135deg);\n  -webkit-transform: rotate(-135deg);\n}\n.down {\n  transform: rotate(45deg);\n  -webkit-transform: rotate(45deg);\n}\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}

















var AnimateCol = (0,motion/* motion */.E)(dist.Col);
var CategoryTitleContainer = (0,styled_components_browser_esm["default"])(typography.H1)(CategoryPage_templateObject());
var CategoryTitle = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div)(CategoryPage_templateObject1());
var LoaderContainer = styled_components_browser_esm["default"].div(CategoryPage_templateObject2());
var LandingPageContainer = styled_components_browser_esm["default"].div(CategoryPage_templateObject3());
var ShowInMobile = styled_components_browser_esm["default"].div(CategoryPage_templateObject5(), dist.media.lg(CategoryPage_templateObject4()));
var MobileSubCatContainer = styled_components_browser_esm["default"].div(_templateObject6(), (0,es/* theme */.rS)("zIndex.select"), (0,es/* palette */.DG)("white"), function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "unset" : "none";
}, function(param) {
    var isOpen = param.isOpen;
    return isOpen ? 1 : 0;
});
var RightContainer = styled_components_browser_esm["default"].div(_templateObject7());
var SortDropdown = styled_components_browser_esm["default"].div(_templateObject10(), (0,es/* palette */.DG)("white"), (0,es/* palette */.DG)("black"), (0,es/* palette */.DG)("black"), (0,es/* palette */.DG)("white"), dist.media.lg(_templateObject8(), (0,es/* palette */.DG)("black")), themes/* theme.palette.error */.r.palette.error, themes/* theme.palette.error */.r.palette.error, dist.media.lg(_templateObject9()));
var GetItem = function(param) {
    var product = param.product, index = param.index;
    if (!product.node.id || !product.node.variants || product.node.variants.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(products/* ProductCard */.Il, {
        slug: product.node.slug,
        render: function(children) {
            var ref;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(AnimateCol, {
                sm: 6,
                md: 4,
                transition: {
                    duration: 0.3,
                    ease: "anticipate",
                    delay: index * 0.1 > 0.2 ? 0.2 : index * 0.1
                },
                initial: {
                    opacity: 0
                },
                animate: {
                    opacity: 1
                },
                exit: {
                    opacity: 0
                },
                children: children
            }, (ref = product.node) === null || ref === void 0 ? void 0 : ref.id);
        }
    }, product.node.id);
};
function CategoryPage(param) {
    var category = param.category, products = param.products, currentCategoryProductsSlug = param.currentCategoryProductsSlug, _filterableAttr = param.filterableAttr, landingPage = param.landingPage, sort = param.sort, updateSortOpt = param.updateSortOpt, envFilter = param.envFilter, updateEnvFilter = param.updateEnvFilter, showLoader = param.showLoader;
    var ref4, ref1, ref2;
    var ref3 = (0,react.useState)(false), showMobileSubCategoryList = ref3[0], setShowMobileSubCategoryList = ref3[1];
    var showProducts = currentCategoryProductsSlug === (category === null || category === void 0 ? void 0 : category.slug);
    var width = (0,useWindowSize/* default */.Z)().width;
    var isMobile = (0,react.useMemo)(function() {
        var minScreenWidth = theme/* default.screenSize.sizeLG.slice */.Z.screenSize.sizeLG.slice(0, -2);
        return width < Number(minScreenWidth);
    }, [
        width
    ]);
    var isTopLevel = !(category === null || category === void 0 ? void 0 : category.parent) && (category === null || category === void 0 ? void 0 : (ref4 = category.children) === null || ref4 === void 0 ? void 0 : (ref1 = ref4.edges) === null || ref1 === void 0 ? void 0 : ref1.length);
    var toogleSubCategoryList = (0,react.useCallback)(function() {
        setShowMobileSubCategoryList(!showMobileSubCategoryList);
    }, [
        showMobileSubCategoryList
    ]);
    var SortContainer = function() {
        var ref = (0,react.useState)(false), showDropdown = ref[0], setShowDropdown = ref[1];
        var handleChange = function(filter) {
            updateSortOpt(filter);
        };
        var options = {
            new: "N\xfdjast",
            price_asc: "L\xe6gsta ver\xf0",
            alph_asc: "Nafn",
            rating: "Rating"
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SortDropdown, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    type: "button",
                    className: "sort-button",
                    onClick: function() {
                        return setShowDropdown(!showDropdown);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: sort ? "Ra\xf0a eftir: ".concat(options[sort]) : "Ra\xf0a eftir: Nafn"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: showDropdown ? "arrow up" : "arrow down"
                        })
                    ]
                }),
                showDropdown && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "options",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    onClick: function() {
                                        return handleChange("new");
                                    },
                                    className: sort === "new" ? "selected" : "",
                                    children: options.new
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    onClick: function() {
                                        return handleChange("price_asc");
                                    },
                                    className: sort === "price_asc" ? "selected" : "",
                                    children: options.price_asc
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    onClick: function() {
                                        return handleChange("alph_asc");
                                    },
                                    className: sort === "alph_asc" ? "selected" : "",
                                    children: options.alph_asc
                                })
                            })
                        ]
                    })
                })
            ]
        });
    };
    var _slug;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* SpacingWrapper */.$3, {
        spacing: 32,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                initial: false,
                exitBeforeEnter: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryTitleContainer, {
                    withGutter: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryTitle, {
                        transition: {
                            duration: 0.2,
                            ease: "anticipate"
                        },
                        initial: {
                            x: 0,
                            opacity: 0
                        },
                        animate: {
                            x: 0,
                            opacity: 1
                        },
                        exit: {
                            x: 300,
                            opacity: 0
                        },
                        children: (category === null || category === void 0 ? void 0 : category.name) || "Vefverslun"
                    }, (category === null || category === void 0 ? void 0 : category.name) || "Vefverslun")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShowInMobile, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* Button */.zx, {
                        fill: true,
                        outlined: true,
                        withGutter: true,
                        onClick: toogleSubCategoryList,
                        children: !showMobileSubCategoryList ? "S\xfdna undirflokka" : "Fela undirflokka"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSubCatContainer, {
                        isOpen: showMobileSubCategoryList,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategorySidebar, {
                            category: category,
                            setShowMobileSubCategoryList: setShowMobileSubCategoryList
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.Row, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                        lg: 3,
                        hiddenLgDown: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategorySidebar, {
                            category: category,
                            isLandingPage: !!(isTopLevel && (landingPage === null || landingPage === void 0 ? void 0 : landingPage.length))
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                        lg: 9,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: (landingPage === null || landingPage === void 0 ? void 0 : landingPage.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingPageContainer, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: landingPage[0].__typename === "BannerRecord" && !isMobile || landingPage[0].__typename === "BannerSliderRecord" && !isMobile ? "landing_container" : "",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DatocmsContent/* DatocmsContent */.P, {
                                        content: landingPage
                                    })
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnimatePresence/* AnimatePresence */.M, {
                                initial: false,
                                children: [
                                    showLoader || showProducts && !products ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderContainer, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Loader */.aN, {
                                            loaderKey: category === null || category === void 0 ? void 0 : category.slug,
                                            size: 48
                                        })
                                    }) : null,
                                    !showLoader && showProducts && products && /*#__PURE__*/ (0,jsx_runtime.jsxs)(RightContainer, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SortContainer, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_form/* Checkbox */.XZ, {
                                                label: "S\xeda vistv\xe6nar v\xf6rur",
                                                checked: envFilter,
                                                onClick: function() {
                                                    return updateEnvFilter(!envFilter);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.Row, {
                                                style: {
                                                    marginTop: "10px"
                                                },
                                                children: [
                                                    (products === null || products === void 0 ? void 0 : products.edges) && !(products === null || products === void 0 ? void 0 : products.edges.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* PLarge */.cG, {
                                                        className: "message-box",
                                                        children: "Engin atri\xf0i til a\xf0 s\xfdna"
                                                    }),
                                                    products === null || products === void 0 ? void 0 : (ref2 = products.edges) === null || ref2 === void 0 ? void 0 : ref2.map(function(product, index) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(GetItem, {
                                                            product: product,
                                                            index: index
                                                        }, (_slug = product.node.slug) !== null && _slug !== void 0 ? _slug : index);
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/api/datocms/utils.ts + 4 modules
var utils = __webpack_require__(39802);
// EXTERNAL MODULE: ./src/api/datocms/queries/index.ts + 2 modules
var queries = __webpack_require__(6487);
// EXTERNAL MODULE: ./node_modules/lodash/capitalize.js
var capitalize = __webpack_require__(48403);
var capitalize_default = /*#__PURE__*/__webpack_require__.n(capitalize);
;// CONCATENATED MODULE: ./src/utils/common/breadcrumbs.ts


var categoryCrumbs = function(category) {
    var ref, ref1;
    var breadcrumbs = [
        {
            title: "Fors\xed\xf0a",
            href: paths/* paths.home */.H.home
        },
        {
            title: "Vefverslun",
            href: paths/* paths.categories */.H.categories
        },
        {
            title: capitalize_default()(category === null || category === void 0 ? void 0 : (ref = category.parent) === null || ref === void 0 ? void 0 : ref.name),
            href: (0,paths/* generatePath */.G)(paths/* paths.categories */.H.categories, category === null || category === void 0 ? void 0 : (ref1 = category.parent) === null || ref1 === void 0 ? void 0 : ref1.slug),
            shallow: true
        },
        {
            title: capitalize_default()(category === null || category === void 0 ? void 0 : category.name),
            href: (0,paths/* generatePath */.G)(paths/* paths.categories */.H.categories, category === null || category === void 0 ? void 0 : category.slug),
            shallow: true
        }, 
    ];
    return breadcrumbs;
};

// EXTERNAL MODULE: ./src/components/genericPage/index.ts + 1 modules
var genericPage = __webpack_require__(39884);
// EXTERNAL MODULE: ./src/utils/isSSR.ts
var isSSR = __webpack_require__(28095);
// EXTERNAL MODULE: ./src/utils/gqlQuery/gqlQuery.ts
var gqlQuery = __webpack_require__(66754);
;// CONCATENATED MODULE: ./src/pages/vefverslun/[slug].tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

/* eslint-disable no-nested-ternary */ /* eslint-disable no-console */ 

















var PER_PAGE = 24;
function Voruflokkur(param1) {
    var pageSubscription = param1.pageSubscription;
    var ref26, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    var ref15 = (0,router.useRouter)(), query = ref15.query, push = ref15.push;
    var slug = Array.isArray(query.slug) ? query.slug[0] : query.slug;
    var ref16 = (0,react.useState)(null), sortOpt = ref16[0], setSortOpt = ref16[1];
    var ref17 = (0,react.useState)(false), envFilter = ref17[0], setEnvFilter = ref17[1];
    var ref18 = (0,react.useState)(false), showLoader = ref18[0], setShowLoader = ref18[1];
    var ref19 = (0,react.useState)(null), categoryProducts = ref19[0], setCategoryProducts = ref19[1];
    var ref20 = (0,react.useState)(), bannerPageContent = ref20[0], setBannerPageContent = ref20[1];
    var AddUrlParams = function(param) {
        var key = param.key, value = param.value;
        // eslint-disable-next-line no-restricted-globals
        var updateUrl = new URL(window.location.href);
        var params = new URLSearchParams(updateUrl.search);
        params.set(key, value !== null && value !== void 0 ? value : "");
        push("".concat(window.location.pathname, "?").concat(params.toString()), undefined, {
            shallow: true
        });
    };
    var deleteUrlParams = function(key) {
        var updateUrl = new URL(window.location.href);
        var params = new URLSearchParams(updateUrl.search);
        params.delete(key);
        push("".concat(window.location.pathname, "?").concat(params.toString()), undefined, {
            shallow: true
        });
    };
    var updateSortOpt = function(val) {
        AddUrlParams({
            key: "sort",
            value: val
        });
        setSortOpt(val);
        setShowLoader(true);
    };
    (0,react.useEffect)(function() {
        if (!query.sort || typeof query.sort !== "string") return;
        if (query.sort && typeof query.sort === "string") {
            setSortOpt(query.sort);
        }
        if (query.ecofriendly) {
            setEnvFilter(true);
        }
    }, [
        query
    ]);
    (0,react.useEffect)(function() {
        if (!sortOpt || query.sort) return;
        if (sortOpt && !query.sort) {
            AddUrlParams({
                key: "sort",
                value: sortOpt
            });
        }
        if (envFilter && !query.ecofriendly) {
            AddUrlParams({
                key: "ecofriendly",
                value: "true"
            });
            setCategoryProducts(null);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        query.slug
    ]);
    var queryParamsFilter = (0,lodash.mapValues)(query, function(v) {
        if (!v) {
            return null;
        }
        return (0,lodash.isArray)(v) ? v : v.split(",");
    });
    var ref21 = (0,_apollo_client.useQuery)(generated/* CategoryDocument */.OtF, {
        fetchPolicy: isSSR/* isSSR */.y ? "cache-only" : "cache-first",
        skip: slug == null,
        variables: {
            slug: slug !== null && slug !== void 0 ? slug : ""
        }
    }), catData = ref21.data, catError = ref21.error, catLoading = ref21.loading;
    // reset landing page data
    (0,react.useEffect)(function() {
        var ref, ref25;
        if (!catData || !bannerPageContent || (catData === null || catData === void 0 ? void 0 : (ref = catData.category) === null || ref === void 0 ? void 0 : ref.slug) === (bannerPageContent === null || bannerPageContent === void 0 ? void 0 : bannerPageContent.categorySlug)) return;
        if (catData && bannerPageContent && (catData === null || catData === void 0 ? void 0 : (ref25 = catData.category) === null || ref25 === void 0 ? void 0 : ref25.slug) !== (bannerPageContent === null || bannerPageContent === void 0 ? void 0 : bannerPageContent.categorySlug)) {
            setBannerPageContent(null);
        }
    }, [
        bannerPageContent,
        bannerPageContent === null || bannerPageContent === void 0 ? void 0 : bannerPageContent.categorySlug,
        catData
    ]);
    var isTopLevel = !!(!(catData === null || catData === void 0 ? void 0 : (ref26 = catData.category) === null || ref26 === void 0 ? void 0 : ref26.parent) && (catData === null || catData === void 0 ? void 0 : (ref1 = catData.category) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.children) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.edges) === null || ref3 === void 0 ? void 0 : ref3.length));
    (0,react.useEffect)(function() {
        var ref30, ref27, ref28;
        if (!(pageSubscription === null || pageSubscription === void 0 ? void 0 : pageSubscription.initialData.categoryLandingPage) || (pageSubscription === null || pageSubscription === void 0 ? void 0 : pageSubscription.initialData.categoryLandingPage.categorySlug) !== (catData === null || catData === void 0 ? void 0 : (ref30 = catData.category) === null || ref30 === void 0 ? void 0 : ref30.slug) || !query.landingPage) return;
        if ((pageSubscription === null || pageSubscription === void 0 ? void 0 : pageSubscription.initialData.categoryLandingPage) && (pageSubscription === null || pageSubscription === void 0 ? void 0 : pageSubscription.initialData.categoryLandingPage.categorySlug) === (catData === null || catData === void 0 ? void 0 : (ref27 = catData.category) === null || ref27 === void 0 ? void 0 : ref27.slug) && query.landingPage) {
            setBannerPageContent(pageSubscription === null || pageSubscription === void 0 ? void 0 : pageSubscription.initialData.categoryLandingPage);
        } else if (isTopLevel && query.landingPage && (!bannerPageContent || (catData === null || catData === void 0 ? void 0 : (ref28 = catData.category) === null || ref28 === void 0 ? void 0 : ref28.slug) !== (bannerPageContent === null || bannerPageContent === void 0 ? void 0 : bannerPageContent.categorySlug))) {
            (0,utils/* makeSubscriptionProps */.qQ)(false, queries/* categoryLandingPageQuery */.qe, {
                categorySlug: slug
            }, false).catch(function(err) {
                console.log({
                    err: err
                });
            }).then(function(data) {
                var ref, ref29;
                setBannerPageContent((ref = data) === null || ref === void 0 ? void 0 : (ref29 = ref.initialData) === null || ref29 === void 0 ? void 0 : ref29.categoryLandingPage);
                return Promise.resolve();
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pageSubscription === null || pageSubscription === void 0 ? void 0 : pageSubscription.initialData.categoryLandingPage,
        catData,
        isTopLevel,
        bannerPageContent,
        slug, 
    ]);
    var ref22 = (0,gqlQuery/* useQueryWithCache */.SR)(generated/* AttributesDocument */.rxx, {
        fetchPolicy: isSSR/* isSSR */.y ? "cache-only" : "cache-first",
        keepKey: {
            slug: slug
        },
        variables: {
            first: 10
        }
    }), attrData = ref22.data, attrError = ref22.error, attrLoading = ref22.loading;
    var ref23 = (0,gqlQuery/* useQueryWithCache */.SR)(generated/* GetAttributesDocument */.o54, {
        fetchPolicy: isSSR/* isSSR */.y ? "cache-only" : "cache-first",
        keepKey: {
            slug: slug
        },
        variables: {
            slug: "certifications-eco"
        }
    }), attributeData = ref23.data, attributeError = ref23.error;
    if (attributeError) {
        console.log("attribute Error");
    }
    var envAttrValues = (0,react.useMemo)(function() {
        var ref, ref31;
        var attrArr = [];
        attributeData === null || attributeData === void 0 ? void 0 : (ref = attributeData.attribute) === null || ref === void 0 ? void 0 : (ref31 = ref.choices) === null || ref31 === void 0 ? void 0 : ref31.edges.forEach(function(choice) {
            return choice.node.slug ? attrArr.push(choice.node.slug) : null;
        });
        return attrArr;
    }, [
        attributeData
    ]);
    var filters = (0,utils_products/* attributeFilters */.vu)(attrData === null || attrData === void 0 ? void 0 : attrData.attributes, queryParamsFilter.filters || []);
    var ref24 = (0,gqlQuery/* useQueryWithCache */.SR)(generated/* ProductsDocument */.SzT, {
        context: {
            nonAuthorized: true
        },
        fetchPolicy: isSSR/* isSSR */.y ? "cache-only" : "cache-first",
        nextFetchPolicy: "cache-first",
        skip: (catData === null || catData === void 0 ? void 0 : (ref4 = catData.category) === null || ref4 === void 0 ? void 0 : ref4.id) == null,
        keepKey: catData === null || catData === void 0 ? void 0 : (ref5 = catData.category) === null || ref5 === void 0 ? void 0 : ref5.slug,
        variables: {
            first: PER_PAGE,
            filter: {
                categories: [
                    catData === null || catData === void 0 ? void 0 : (ref6 = catData.category) === null || ref6 === void 0 ? void 0 : ref6.id
                ].filter(utils_isNotNull/* isNotNull */.K),
                attributes: envFilter ? [
                    {
                        slug: "certifications-eco",
                        values: _toConsumableArray(envAttrValues)
                    }, 
                ].concat(_toConsumableArray(filters)) : filters
            },
            sortBy: sortOpt ? utils_products/* sortingArgsMap */.S1[sortOpt][0] : null
        }
    }), fetchMore = ref24.fetchMore, catProducts = ref24.data, catProductsError = ref24.error, catProductsLoading = ref24.loading, catProductsCurrentSlug = ref24.keepKey;
    (0,react.useEffect)(function() {
        if (!catProducts || !showLoader || envFilter) return;
        if (catProducts && showLoader && !envFilter) {
            setShowLoader(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        catProducts
    ]);
    (0,react.useEffect)(function() {
        var ref34, ref32;
        if (!envFilter || !envAttrValues.length || !(catData === null || catData === void 0 ? void 0 : (ref34 = catData.category) === null || ref34 === void 0 ? void 0 : ref34.id)) return;
        if (envFilter && envAttrValues.length && (catData === null || catData === void 0 ? void 0 : (ref32 = catData.category) === null || ref32 === void 0 ? void 0 : ref32.id)) {
            var ref33;
            setShowLoader(true);
            fetchMore({
                variables: {
                    first: PER_PAGE,
                    filter: {
                        categories: [
                            catData === null || catData === void 0 ? void 0 : (ref33 = catData.category) === null || ref33 === void 0 ? void 0 : ref33.id
                        ].filter(utils_isNotNull/* isNotNull */.K),
                        attributes: [
                            {
                                slug: "certifications-eco",
                                values: _toConsumableArray(envAttrValues)
                            }, 
                        ]
                    },
                    sortBy: sortOpt ? utils_products/* sortingArgsMap */.S1[sortOpt][0] : null
                }
            }).then(function(data) {
                var ref;
                setCategoryProducts(data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.products);
                setShowLoader(false);
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        envFilter,
        catData === null || catData === void 0 ? void 0 : (ref7 = catData.category) === null || ref7 === void 0 ? void 0 : ref7.id,
        sortOpt,
        envAttrValues
    ]);
    var updateEnvFilter = function(val) {
        if (!val) {
            var ref;
            fetchMore({
                variables: {
                    first: PER_PAGE,
                    filter: {
                        categories: [
                            catData === null || catData === void 0 ? void 0 : (ref = catData.category) === null || ref === void 0 ? void 0 : ref.id
                        ].filter(utils_isNotNull/* isNotNull */.K),
                        attributes: filters
                    },
                    sortBy: sortOpt ? utils_products/* sortingArgsMap */.S1[sortOpt][0] : null
                }
            });
            setEnvFilter(false);
            setCategoryProducts(null);
            deleteUrlParams("ecofriendly");
            return;
        }
        setShowLoader(true);
        setEnvFilter(true);
        AddUrlParams({
            key: "ecofriendly",
            value: "true"
        });
    };
    var handleFetchMore = (0,react.useCallback)(function() {
        var ref41, ref35, ref36, ref37;
        if (envFilter && (categoryProducts === null || categoryProducts === void 0 ? void 0 : (ref41 = categoryProducts.edges) === null || ref41 === void 0 ? void 0 : ref41.length)) {
            var ref38;
            fetchMore({
                variables: {
                    after: categoryProducts.edges[categoryProducts.edges.length - 1].cursor,
                    filter: {
                        categories: [
                            catData === null || catData === void 0 ? void 0 : (ref38 = catData.category) === null || ref38 === void 0 ? void 0 : ref38.id
                        ].filter(utils_isNotNull/* isNotNull */.K),
                        attributes: [
                            {
                                slug: "certifications-eco",
                                values: _toConsumableArray(envAttrValues)
                            }, 
                        ]
                    }
                }
            }).then(function(data) {
                setCategoryProducts(function(prev) {
                    var ref, ref39;
                    if ((prev === null || prev === void 0 ? void 0 : (ref = prev.edges) === null || ref === void 0 ? void 0 : ref.length) && data) {
                        var ref40;
                        var updateProducts = data === null || data === void 0 ? void 0 : (ref40 = data.data) === null || ref40 === void 0 ? void 0 : ref40.products;
                        return {
                            pageInfo: updateProducts.pageInfo,
                            totalCount: updateProducts.totalCount,
                            edges: _toConsumableArray(prev === null || prev === void 0 ? void 0 : prev.edges).concat(_toConsumableArray(updateProducts.edges))
                        };
                    }
                    return data === null || data === void 0 ? void 0 : (ref39 = data.data) === null || ref39 === void 0 ? void 0 : ref39.products;
                });
            });
            return;
        }
        if (!(catProducts === null || catProducts === void 0 ? void 0 : (ref35 = catProducts.products) === null || ref35 === void 0 ? void 0 : (ref36 = ref35.pageInfo) === null || ref36 === void 0 ? void 0 : ref36.hasNextPage) || !((ref37 = catProducts.products.edges) === null || ref37 === void 0 ? void 0 : ref37.length)) {
            return;
        }
        fetchMore({
            variables: {
                after: catProducts.products.edges[catProducts.products.edges.length - 1].cursor
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        catProducts === null || catProducts === void 0 ? void 0 : (ref8 = catProducts.products) === null || ref8 === void 0 ? void 0 : ref8.edges,
        catProducts === null || catProducts === void 0 ? void 0 : (ref9 = catProducts.products) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.pageInfo) === null || ref10 === void 0 ? void 0 : ref10.hasNextPage,
        categoryProducts === null || categoryProducts === void 0 ? void 0 : categoryProducts.edges,
        envFilter,
        fetchMore, 
    ]);
    var loading = catLoading || attrLoading;
    var error = !!catError || !!attrError || !!catProductsError;
    if (!isSSR/* isSSR */.y && loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(genericPage/* PageLoading */.S, {});
    }
    if (error || !catData) {
        // TODO: Better error handling
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(genericPage/* PageContent */.J, {
            label: "Villa",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Container, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.H2, {
                    children: "Villa"
                })
            })
        });
    }
    if (!catData || !catData.category || !catData.category.name) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(genericPage/* PageContent */.J, {
            label: "V\xf6ruflokkur finnst ekki",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Container, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.H2, {
                    children: "V\xf6ruflokkur finnst ekki"
                })
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(genericPage/* PageContent */.J, {
        label: catData.category.name,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(products/* Breadcrumbs */.Oo, {
                    breadcrumbs: categoryCrumbs(catData === null || catData === void 0 ? void 0 : catData.category)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryPage, {
                    category: catData === null || catData === void 0 ? void 0 : catData.category,
                    products: envFilter && categoryProducts ? categoryProducts : catProducts === null || catProducts === void 0 ? void 0 : catProducts.products,
                    currentCategoryProductsSlug: catProductsCurrentSlug,
                    filterableAttr: attrData === null || attrData === void 0 ? void 0 : attrData.attributes,
                    landingPage: query.landingPage ? bannerPageContent === null || bannerPageContent === void 0 ? void 0 : bannerPageContent.content : null,
                    sort: sortOpt,
                    updateSortOpt: updateSortOpt,
                    envFilter: envFilter,
                    updateEnvFilter: updateEnvFilter,
                    showLoader: showLoader
                }),
                !(bannerPageContent === null || bannerPageContent === void 0 ? void 0 : (ref11 = bannerPageContent.content) === null || ref11 === void 0 ? void 0 : ref11.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Voruflokkur.PaginInationIndicator, {
                    currentCount: envFilter && categoryProducts ? categoryProducts === null || categoryProducts === void 0 ? void 0 : (ref12 = categoryProducts.edges) === null || ref12 === void 0 ? void 0 : ref12.length : catProducts === null || catProducts === void 0 ? void 0 : (ref13 = catProducts.products) === null || ref13 === void 0 ? void 0 : ref13.edges.length,
                    totalCount: envFilter && categoryProducts ? categoryProducts.totalCount : catProducts === null || catProducts === void 0 ? void 0 : (ref14 = catProducts.products) === null || ref14 === void 0 ? void 0 : ref14.totalCount,
                    onClickMore: handleFetchMore,
                    loading: catProductsLoading
                }) : null
            ]
        })
    });
}
Voruflokkur.PaginInationIndicator = function(param) {
    var loading = param.loading, currentCount = param.currentCount, totalCount = param.totalCount, onClickMore = param.onClickMore;
    if (loading || !currentCount || !totalCount) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* PaginationIndicator */.Ze, {
        currentCount: currentCount,
        totalCount: totalCount,
        onClickMore: onClickMore
    });
};
var __N_SSP = true;
/* harmony default export */ var _slug_ = (Voruflokkur);


/***/ }),

/***/ 17563:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

const strictUriEncode = __webpack_require__(70610);
const decodeComponent = __webpack_require__(44020);
const splitOnFirst = __webpack_require__(80500);
const filterObject = __webpack_require__(92806);

const isNullOrUndefined = value => value === null || value === undefined;

const encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');

function encoderForArrayFormat(options) {
	switch (options.arrayFormat) {
		case 'index':
			return key => (result, value) => {
				const index = result.length;

				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, [encode(key, options), '[', index, ']'].join('')];
				}

				return [
					...result,
					[encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join('')
				];
			};

		case 'bracket':
			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, [encode(key, options), '[]'].join('')];
				}

				return [...result, [encode(key, options), '[]=', encode(value, options)].join('')];
			};

		case 'comma':
		case 'separator':
		case 'bracket-separator': {
			const keyValueSep = options.arrayFormat === 'bracket-separator' ?
				'[]=' :
				'=';

			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				// Translate null to an empty string so that it doesn't serialize as 'null'
				value = value === null ? '' : value;

				if (result.length === 0) {
					return [[encode(key, options), keyValueSep, encode(value, options)].join('')];
				}

				return [[result, encode(value, options)].join(options.arrayFormatSeparator)];
			};
		}

		default:
			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, encode(key, options)];
				}

				return [...result, [encode(key, options), '=', encode(value, options)].join('')];
			};
	}
}

function parserForArrayFormat(options) {
	let result;

	switch (options.arrayFormat) {
		case 'index':
			return (key, value, accumulator) => {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return (key, value, accumulator) => {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		case 'comma':
		case 'separator':
			return (key, value, accumulator) => {
				const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
				const isEncodedArray = (typeof value === 'string' && !isArray && decode(value, options).includes(options.arrayFormatSeparator));
				value = isEncodedArray ? decode(value, options) : value;
				const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(item => decode(item, options)) : value === null ? value : decode(value, options);
				accumulator[key] = newValue;
			};

		case 'bracket-separator':
			return (key, value, accumulator) => {
				const isArray = /(\[\])$/.test(key);
				key = key.replace(/\[\]$/, '');

				if (!isArray) {
					accumulator[key] = value ? decode(value, options) : value;
					return;
				}

				const arrayValue = value === null ?
					[] :
					value.split(options.arrayFormatSeparator).map(item => decode(item, options));

				if (accumulator[key] === undefined) {
					accumulator[key] = arrayValue;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], arrayValue);
			};

		default:
			return (key, value, accumulator) => {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function validateArrayFormatSeparator(value) {
	if (typeof value !== 'string' || value.length !== 1) {
		throw new TypeError('arrayFormatSeparator must be single character string');
	}
}

function encode(value, options) {
	if (options.encode) {
		return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function decode(value, options) {
	if (options.decode) {
		return decodeComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	}

	if (typeof input === 'object') {
		return keysSorter(Object.keys(input))
			.sort((a, b) => Number(a) - Number(b))
			.map(key => input[key]);
	}

	return input;
}

function removeHash(input) {
	const hashStart = input.indexOf('#');
	if (hashStart !== -1) {
		input = input.slice(0, hashStart);
	}

	return input;
}

function getHash(url) {
	let hash = '';
	const hashStart = url.indexOf('#');
	if (hashStart !== -1) {
		hash = url.slice(hashStart);
	}

	return hash;
}

function extract(input) {
	input = removeHash(input);
	const queryStart = input.indexOf('?');
	if (queryStart === -1) {
		return '';
	}

	return input.slice(queryStart + 1);
}

function parseValue(value, options) {
	if (options.parseNumbers && !Number.isNaN(Number(value)) && (typeof value === 'string' && value.trim() !== '')) {
		value = Number(value);
	} else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
		value = value.toLowerCase() === 'true';
	}

	return value;
}

function parse(query, options) {
	options = Object.assign({
		decode: true,
		sort: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ',',
		parseNumbers: false,
		parseBooleans: false
	}, options);

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const formatter = parserForArrayFormat(options);

	// Create an object with no prototype
	const ret = Object.create(null);

	if (typeof query !== 'string') {
		return ret;
	}

	query = query.trim().replace(/^[?#&]/, '');

	if (!query) {
		return ret;
	}

	for (const param of query.split('&')) {
		if (param === '') {
			continue;
		}

		let [key, value] = splitOnFirst(options.decode ? param.replace(/\+/g, ' ') : param, '=');

		// Missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		value = value === undefined ? null : ['comma', 'separator', 'bracket-separator'].includes(options.arrayFormat) ? value : decode(value, options);
		formatter(decode(key, options), value, ret);
	}

	for (const key of Object.keys(ret)) {
		const value = ret[key];
		if (typeof value === 'object' && value !== null) {
			for (const k of Object.keys(value)) {
				value[k] = parseValue(value[k], options);
			}
		} else {
			ret[key] = parseValue(value, options);
		}
	}

	if (options.sort === false) {
		return ret;
	}

	return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key) => {
		const value = ret[key];
		if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) {
			// Sort object keys, not values
			result[key] = keysSorter(value);
		} else {
			result[key] = value;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = (object, options) => {
	if (!object) {
		return '';
	}

	options = Object.assign({
		encode: true,
		strict: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ','
	}, options);

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const shouldFilter = key => (
		(options.skipNull && isNullOrUndefined(object[key])) ||
		(options.skipEmptyString && object[key] === '')
	);

	const formatter = encoderForArrayFormat(options);

	const objectCopy = {};

	for (const key of Object.keys(object)) {
		if (!shouldFilter(key)) {
			objectCopy[key] = object[key];
		}
	}

	const keys = Object.keys(objectCopy);

	if (options.sort !== false) {
		keys.sort(options.sort);
	}

	return keys.map(key => {
		const value = object[key];

		if (value === undefined) {
			return '';
		}

		if (value === null) {
			return encode(key, options);
		}

		if (Array.isArray(value)) {
			if (value.length === 0 && options.arrayFormat === 'bracket-separator') {
				return encode(key, options) + '[]';
			}

			return value
				.reduce(formatter(key), [])
				.join('&');
		}

		return encode(key, options) + '=' + encode(value, options);
	}).filter(x => x.length > 0).join('&');
};

exports.parseUrl = (url, options) => {
	options = Object.assign({
		decode: true
	}, options);

	const [url_, hash] = splitOnFirst(url, '#');

	return Object.assign(
		{
			url: url_.split('?')[0] || '',
			query: parse(extract(url), options)
		},
		options && options.parseFragmentIdentifier && hash ? {fragmentIdentifier: decode(hash, options)} : {}
	);
};

exports.stringifyUrl = (object, options) => {
	options = Object.assign({
		encode: true,
		strict: true,
		[encodeFragmentIdentifier]: true
	}, options);

	const url = removeHash(object.url).split('?')[0] || '';
	const queryFromUrl = exports.extract(object.url);
	const parsedQueryFromUrl = exports.parse(queryFromUrl, {sort: false});

	const query = Object.assign(parsedQueryFromUrl, object.query);
	let queryString = exports.stringify(query, options);
	if (queryString) {
		queryString = `?${queryString}`;
	}

	let hash = getHash(object.url);
	if (object.fragmentIdentifier) {
		hash = `#${options[encodeFragmentIdentifier] ? encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
	}

	return `${url}${queryString}${hash}`;
};

exports.pick = (input, filter, options) => {
	options = Object.assign({
		parseFragmentIdentifier: true,
		[encodeFragmentIdentifier]: false
	}, options);

	const {url, query, fragmentIdentifier} = exports.parseUrl(input, options);
	return exports.stringifyUrl({
		url,
		query: filterObject(query, filter),
		fragmentIdentifier
	}, options);
};

exports.exclude = (input, filter, options) => {
	const exclusionFilter = Array.isArray(filter) ? key => !filter.includes(key) : (key, value) => !filter(key, value);

	return exports.pick(input, exclusionFilter, options);
};


/***/ }),

/***/ 80500:
/***/ (function(module) {

"use strict";


module.exports = (string, separator) => {
	if (!(typeof string === 'string' && typeof separator === 'string')) {
		throw new TypeError('Expected the arguments to be of type `string`');
	}

	if (separator === '') {
		return [string];
	}

	const separatorIndex = string.indexOf(separator);

	if (separatorIndex === -1) {
		return [string];
	}

	return [
		string.slice(0, separatorIndex),
		string.slice(separatorIndex + separator.length)
	];
};


/***/ }),

/***/ 70610:
/***/ (function(module) {

"use strict";

module.exports = str => encodeURIComponent(str).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [370,466,104,12,127,221,774,888,179], function() { return __webpack_exec__(15700); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);